import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IReportSlice {
  isPurchaseCompleted: boolean;
  isDownload: boolean;
  countBookmark: Record<number, number>;
  pageShareCurrent: number | null;
  pageShareArray: number[] | null;
  allowShareReport?: boolean;
  isShowFavorite?: boolean;
}

const initialState: IReportSlice = {
  isPurchaseCompleted: false,
  isDownload: false,
  countBookmark: {},
  pageShareCurrent: null,
  pageShareArray: null,
  allowShareReport: false,
  isShowFavorite: false,
};

export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setPurchaseCompleted: (state, action: PayloadAction<boolean>) => {
      state.isPurchaseCompleted = action.payload;
    },
    setDownload: (state, action: PayloadAction<boolean>) => {
      state.isDownload = action.payload;
    },
    setCountBookmark: (state, action: PayloadAction<Record<number, number>>) => {
      state.countBookmark = action.payload;
    },
    setPageShareCurrent: (state, action: PayloadAction<number | null>) => {
      state.pageShareCurrent = action.payload;
    },
    setPageShareArray: (state, action: PayloadAction<number[] | null>) => {
      state.pageShareArray = action.payload;
    },
    setAllowShareReport: (state, action: PayloadAction<boolean | undefined>) => {
      state.allowShareReport = action.payload;
    },
    setIsShowFavorite: (state, action: PayloadAction<boolean>) => {
      state.isShowFavorite = action.payload;
    }
  },
});

export const { setPurchaseCompleted, setDownload,setCountBookmark,setPageShareCurrent,setPageShareArray,setAllowShareReport, setIsShowFavorite} = reportSlice.actions;
export default reportSlice.reducer;
